module.exports = __webpack_public_path__ + "static/media/FounderKatarzyna.7e2f1078.png";